import { TypedUseSelectorHook, useDispatch, useSelector } from "react-redux";
import { RootState } from "state/rootReducer";
import { AppDispatch } from "state/store";

export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;

/** Thunk-aware dispatch. Plain useDispatch() cannot accept an AppThunk. */
export const useAppDispatch: () => AppDispatch = useDispatch;
